module.exports = __webpack_public_path__ + "static/media/express.5cded32e.svg";